<div
  class="attribute-editor-component"
  rvSpinner="custom-font-selector-editor-loader"
  [rvShowSpinner]="spinner"
>
  <basic-uploader
    [uploaderId]="'custom-font-uploader'"
    [uploadManager]="storageUploadManager"
    [validType]="fileType"
    [shown]="isUploading"
  >
  </basic-uploader>
  <div class="attribute-editor-component">
    <div class="attribute-editor-row">
      <div
        class="form-group has-feedback"
        [ngClass]="{
          'has-error': validationResult && validationResult !== 'VALID',
          'has-success': validationResult === 'VALID' && fontUrl !== '',
        }"
      >
        <label for="custom-font-url">Font URL</label>
        <p>
          Enter the direct URL to a .otf, .ttf, .woff, or .woff2 font file
          hosted on your server or storage.
        </p>
        <input
          type="text"
          id="custom-font-url"
          class="form-control u_ellipsis"
          [(ngModel)]="fontUrl"
          placeholder="https://"
          (debounceEvent)="fontUrlChanged()"
          (ngModelChange)="clearValidationResult()"
        />
        <!-- TODO: we can convert to a switch if/when we want to display different error messages per validation result -->
        <p
          class="help-block"
          [shown]="validationResult && validationResult !== 'VALID'"
        >
          Invalid URL. Please enter a valid font file URL (.otf, .ttf, .woff,
          .woff2).
        </p>
        <button
          class="btn btn-primary btn-block mt-4"
          [disabled]="!fontUrl || validationResult !== 'VALID'"
          (click)="saveFontUrl()"
        >
          Save URL
        </button>
      </div>
      <div class="or-separator">
        <span>or</span>
      </div>
      <div>
        <button
          id="upload-file-unsubscribed"
          matButton="outlined"
          class="tw-w-full"
          (click)="currentPlanService.showUnlockThisFeatureModal()"
          [hidden]="currentPlanService.isPlanActive()"
        >
          Upload Font
        </button>
        <button
          type="button"
          matButton="outlined"
          (click)="activateUploader()"
          id="custom-font-uploader-label"
          class="tw-w-full aligner"
          [disabled]="isUploading"
          [shown]="currentPlanService.isPlanActive()"
        >
          Upload Font
        </button>
      </div>
      <div>
        <button
          id="te-font-select"
          matButton="outlined"
          class="tw-w-full tw-mt-4"
          [disabled]="isUploading"
          (click)="selectFromStorage()"
        >
          Select from Storage
        </button>
      </div>
    </div>
  </div>
</div>
